import { Resources } from 'constants/resources';

import { ResourceProps } from 'react-admin';

import { OrdersBulkUpdateForm } from './OrdersBulkUpdateForm';

export const ordersBulkUpdateFormResource: ResourceProps = {
  name: Resources.OrdersBulkUpdate,
  create: <></>,
  edit: <></>,
  show: <></>,
  list: OrdersBulkUpdateForm,
};
